import { AnimationBuilder } from '@angular/animations';

import { BehaviorSubject } from 'rxjs';

import { SlideComponent } from '../slide.component';

export enum SlideDirection {
    Left = 'Left',
    Right = 'Right',
}

export abstract class BaseSlideBehavior {
    protected maxSlideIndex: number;
    private _currentSlideIndex: number;
    protected animationDuration = 350;
    protected slideChanged = new BehaviorSubject<SlideComponent | null>(null);

    slideChanged$ = this.slideChanged.asObservable();

    constructor(
        protected slides: SlideComponent[],
        protected animationBuilder: AnimationBuilder,
        initialSlideIndex: number,
    ) {
        this.maxSlideIndex = slides.length - 1;
        this._currentSlideIndex = initialSlideIndex;
    }

    abstract slideRight(): void;
    abstract get canSlideRight(): boolean;
    abstract slideLeft(): void;
    abstract get canSlideLeft(): boolean;

    /**
     * Moves the slideshow to the desired slide index.
     *
     * @param {number} slideIndex
     * @param {SlideDirection} [forceSlideDirection] If not provided, the direction of the slide will be calculated based on the index.
     * @returns {void}
     * @memberof OneSlideBehavior
     */
    abstract slideTo(slideIndex: number, forceSlideDirection?: SlideDirection): void;

    protected nextSlideIndex(crtSlideIndex?: number, max?: number): number {
        return this.nextIndex(crtSlideIndex || this._currentSlideIndex, max || this.maxSlideIndex);
    }

    protected previousSlideIndex(crtSlideIndex?: number): number {
        return this.previousIndex(crtSlideIndex || this._currentSlideIndex, 0, this.maxSlideIndex);
    }

    protected limitNumber(val: number, min: number, max: number): number {
        return val < min ? min : val > max ? max : val;
    }

    protected emitSlideChanged(): void {
        this.slideChanged.next(this.slides[this._currentSlideIndex]);
    }

    private nextIndex(val: number, max: number): number {
        if (val === max) {
            return 0;
        }

        return val + 1;
    }

    private previousIndex(val: number, min: number, max: number): number {
        if (val === min) {
            return max;
        }

        return val - 1;
    }

    get currentSlideIndex(): number {
        return this._currentSlideIndex;
    }

    set currentSlideIndex(value: number) {
        this._currentSlideIndex = value;
    }
}
